export const adminRoute = {
  base: '/super-admin',
  jobs: '/jobs',
  crm: '/crm',
  leads: '/leads',
  clients: '/clients',
  communication: '/communication',
  quotes: '/quotes',
  inventory: '/inventory',
  product: '/product',
  package: '/package',
  settings: '/settings',
  users: '/users',
  schedule: '/schedule',
  vehicles: '/vehicles',
  trucks: '/trucks',
  equipments: '/equipments',
  trailers: '/trailers',
  vendors: '/vendors',
  purchaseOrder: '/purchase-order',
  order: '/order',
  roleManagement: '/role-management',
  coupon: '/coupon',
  eventType: '/event-type',
  category: '/category',
  quarantines: '/quarantine',
  invoice: '/invoice',
  checklist: '/checklist',
  task: '/task',
  global: '/global',
  venue: '/venue',

  // Reports
  reports: '/reports',
  overbookingItem: '/overbooking-item',
  subrentalsReport: '/subrentals',
  quarantineReport: '/quarantine',
  foremanTaskReport: '/foreman-task-completion',
  clientIncomeReport: '/client-income',
  revenueReport: '/revenue',
  geographicRevenueReport: '/geographic-revenue',
  quoteRevenueReport: '/quote-revenue',
  orderRevenueReport: '/order-revenue',
  cancellationReport: '/cancellation',
  deliveryReport: '/delivery-pickup',
  taskCompletionReport: '/task-completion',
  discountUsageReport: '/discount-usage',
  featureUtilizationReport: '/feature-utilization',
  jobCostingReport: '/job-costing',
  inventoryUsageReport: '/inventory-usage',
  marketingRevenueReport: '/marketing-revenue',
  financialOrderReport: '/financial-order',
  transactionSummaryReport: '/transaction-summary',

  // Common
  commonCreate: '/create',
  commonEdit: '/edit',
  commonClone: '/clone',
  commonDetail: '/:id',
};

export const adminRouteVehicles = {
  vehicles: `${adminRoute.base}${adminRoute.vehicles}`,
};

export const adminRouteTrucks = {
  trucks: `${adminRoute.base}${adminRoute.vehicles}${adminRoute.trucks}`,
};

export const adminRouteEquipments = {
  equipments: `${adminRoute.base}${adminRoute.vehicles}${adminRoute.equipments}`,
};

export const adminRouteTrailers = {
  trailers: `${adminRoute.base}${adminRoute.vehicles}${adminRoute.trailers}`,
};

export const adminRouteVendors = {
  vendors: `${adminRoute.base}${adminRoute.vendors}`,
  detailVendor: `${adminRoute.base}${adminRoute.vendors}${adminRoute.commonDetail}`,
};

export const adminRoutePurchaseOrder = {
  purchaseOrder: `${adminRoute.base}${adminRoute.purchaseOrder}`,
  detailPurchaseOrder: (purchaseOrderId: string) => `${adminRoute.base}${adminRoute.purchaseOrder}/${purchaseOrderId}`,
};

export const adminRouteOrder = {
  order: `${adminRoute.base}${adminRoute.order}`,
  detailOrder: (orderId: string) => `${adminRoute.base}${adminRoute.order}/${orderId}`,
  updateOrder: (orderId: string) => `${adminRoute.base}${adminRoute.order}/${orderId}${adminRoute.commonEdit}`,
};

export const adminRouteCrm = {
  crm: `${adminRoute.base}${adminRoute.crm}`,
  leads: `${adminRoute.base}${adminRoute.crm}${adminRoute.leads}`,
  createLead: `${adminRoute.base}${adminRoute.crm}${adminRoute.leads}${adminRoute.commonCreate}`,
  detailLead: (leadId: string) => `${adminRoute.base}${adminRoute.crm}${adminRoute.leads}/${leadId}`,
  updateLead: (leadId: string) =>
    `${adminRoute.base}${adminRoute.crm}${adminRoute.leads}/${leadId}${adminRoute.commonEdit}`,
  clients: `${adminRoute.base}${adminRoute.crm}${adminRoute.clients}`,
  createClient: `${adminRoute.base}${adminRoute.crm}${adminRoute.clients}${adminRoute.commonCreate}`,
  detailClient: (clientId: string) => `${adminRoute.base}${adminRoute.crm}${adminRoute.clients}/${clientId}`,
  updateClient: (clientId: string) =>
    `${adminRoute.base}${adminRoute.crm}${adminRoute.clients}/${clientId}${adminRoute.commonEdit}`,
};

export const adminRouteQuote = {
  quotes: `${adminRoute.base}${adminRoute.quotes}`,
  createQuotes: `${adminRoute.base}${adminRoute.quotes}${adminRoute.commonCreate}`,
  detailQuote: (quoteId: string) => `${adminRoute.base}${adminRoute.quotes}/${quoteId}`,
  updateQuote: (quoteId: string) => `${adminRoute.base}${adminRoute.quotes}/${quoteId}${adminRoute.commonEdit}`,
};

export const adminRouteInventory = {
  inventories: `${adminRoute.base}${adminRoute.inventory}`,
  inventory: `${adminRoute.base}${adminRoute.inventory}${adminRoute.product}`,
  createInventory: `${adminRoute.base}${adminRoute.inventory}${adminRoute.product}${adminRoute.commonCreate}`,
  detailInventory: (inventoryId: string) =>
    `${adminRoute.base}${adminRoute.inventory}${adminRoute.product}/${inventoryId}`,
  updateInventory: (inventoryId: string) =>
    `${adminRoute.base}${adminRoute.inventory}${adminRoute.product}/${inventoryId}${adminRoute.commonEdit}`,
};

export const adminRoutePackage = {
  package: `${adminRoute.base}${adminRoute.inventory}${adminRoute.package}`,
  createPackage: `${adminRoute.base}${adminRoute.inventory}${adminRoute.package}${adminRoute.commonCreate}`,
  updatePackage: (packageId: string) =>
    `${adminRoute.base}${adminRoute.inventory}${adminRoute.package}/${packageId}${adminRoute.commonEdit}`,
  clonePackage: (packageId: string) =>
    `${adminRoute.base}${adminRoute.inventory}${adminRoute.package}/${packageId}${adminRoute.commonClone}`,
};

export const adminRouteUser = {
  users: `${adminRoute.base}${adminRoute.settings}${adminRoute.users}`,
  createUser: `${adminRoute.base}${adminRoute.settings}${adminRoute.users}${adminRoute.commonCreate}`,
  detailUser: (userId: string) => `${adminRoute.base}${adminRoute.settings}${adminRoute.users}/${userId}`,
  updateUser: (userId: string) =>
    `${adminRoute.base}${adminRoute.settings}${adminRoute.users}/${userId}${adminRoute.commonEdit}`,
};

export const adminRouteVenue = {
  venue: `${adminRoute.base}${adminRoute.settings}${adminRoute.venue}`,
  createVenue: `${adminRoute.base}${adminRoute.settings}${adminRoute.venue}${adminRoute.commonCreate}`,
  detailVenue: (venueId: string) => `${adminRoute.base}${adminRoute.settings}${adminRoute.venue}/${venueId}`,
  updateVenue: (venueId: string) =>
    `${adminRoute.base}${adminRoute.settings}${adminRoute.venue}/${venueId}${adminRoute.commonEdit}`,
};

export const adminRouteInvoice = {
  invoices: `${adminRoute.base}${adminRoute.invoice}`,
  createInvoice: `${adminRoute.base}${adminRoute.invoice}${adminRoute.commonCreate}`,
  updateInvoice: (invoiceId: string) => `${adminRoute.base}${adminRoute.invoice}/${invoiceId}${adminRoute.commonEdit}`,
};

export const adminRouteRoleManagement = {
  roleManagement: `${adminRoute.base}${adminRoute.settings}${adminRoute.roleManagement}`,
  createRole: `${adminRoute.base}${adminRoute.settings}${adminRoute.roleManagement}${adminRoute.commonCreate}`,
  updateRole: (roleId: string) =>
    `${adminRoute.base}${adminRoute.settings}${adminRoute.roleManagement}/${roleId}${adminRoute.commonEdit}`,
};

export const adminRouteRoleCoupon = {
  coupon: `${adminRoute.base}${adminRoute.settings}${adminRoute.coupon}`,
};

export const adminRouteRoleEventType = {
  eventType: `${adminRoute.base}${adminRoute.settings}${adminRoute.eventType}`,
};

export const adminRouteRoleCategory = {
  category: `${adminRoute.base}${adminRoute.settings}${adminRoute.category}`,
};

export const adminRouteRoleChecklist = {
  checklist: `${adminRoute.base}${adminRoute.settings}${adminRoute.checklist}`,
};

export const adminRouteJob = {
  jobs: `${adminRoute.base}${adminRoute.jobs}`,
  detailJob: (jobId: string) => `${adminRoute.base}${adminRoute.jobs}/${jobId}`,
};

export const adminRouteQuarantine = {
  quarantine: `${adminRoute.base}${adminRoute.inventory}${adminRoute.quarantines}`,
};

export const adminRouteTask = {
  task: `${adminRoute.base}${adminRoute.task}`,
};

export const adminRouteGlobal = {
  global: `${adminRoute.base}${adminRoute.global}`,
};

export const adminRouteReport = {
  reports: `${adminRoute.base}${adminRoute.reports}`,
  overbookingItem: `${adminRoute.base}${adminRoute.reports}${adminRoute.overbookingItem}`,
  subrentalsReport: `${adminRoute.base}${adminRoute.reports}${adminRoute.subrentalsReport}`,
  clientIncomeReport: `${adminRoute.base}${adminRoute.reports}${adminRoute.clientIncomeReport}`,
  revenueReport: `${adminRoute.base}${adminRoute.reports}${adminRoute.revenueReport}`,
  geographicRevenueReport: `${adminRoute.base}${adminRoute.reports}${adminRoute.geographicRevenueReport}`,
  quoteRevenueReport: `${adminRoute.base}${adminRoute.reports}${adminRoute.quoteRevenueReport}`,
  orderRevenueReport: `${adminRoute.base}${adminRoute.reports}${adminRoute.orderRevenueReport}`,
  cancellationReport: `${adminRoute.base}${adminRoute.reports}${adminRoute.cancellationReport}`,
  deliveryReport: `${adminRoute.base}${adminRoute.reports}${adminRoute.deliveryReport}`,
  taskCompletionReport: `${adminRoute.base}${adminRoute.reports}${adminRoute.taskCompletionReport}`,
  discountUsageReport: `${adminRoute.base}${adminRoute.reports}${adminRoute.discountUsageReport}`,
  featureUtilizationReport: `${adminRoute.base}${adminRoute.reports}${adminRoute.featureUtilizationReport}`,
  jobCostingReport: `${adminRoute.base}${adminRoute.reports}${adminRoute.jobCostingReport}`,
  inventoryUsageReport: `${adminRoute.base}${adminRoute.reports}${adminRoute.inventoryUsageReport}`,
  quarantineReport: `${adminRoute.base}${adminRoute.reports}${adminRoute.quarantineReport}`,
  foremanTaskReport: `${adminRoute.base}${adminRoute.reports}${adminRoute.foremanTaskReport}`,
  marketingRevenueReport: `${adminRoute.base}${adminRoute.reports}${adminRoute.marketingRevenueReport}`,
  financialOrderReport: `${adminRoute.base}${adminRoute.reports}${adminRoute.financialOrderReport}`,
  transactionSummaryReport: `${adminRoute.base}${adminRoute.reports}${adminRoute.transactionSummaryReport}`,
};

export const adminRouteAbsolute = {
  // Dashboard
  dashboard: adminRoute.base,

  // Communication
  communication: `${adminRoute.base}${adminRoute.communication}`,

  // Settings
  settings: `${adminRoute.base}${adminRoute.settings}`,

  // Schedule
  schedule: `${adminRoute.base}${adminRoute.schedule}`,

  ...adminRouteVehicles,
  ...adminRouteTrucks,
  ...adminRouteEquipments,
  ...adminRouteTrailers,
  ...adminRouteVendors,
  ...adminRoutePurchaseOrder,
  ...adminRouteOrder,
  ...adminRouteCrm,
  ...adminRouteQuote,
  ...adminRouteInventory,
  ...adminRoutePackage,
  ...adminRouteUser,
  ...adminRouteVenue,
  ...adminRouteRoleManagement,
  ...adminRouteRoleCoupon,
  ...adminRouteRoleEventType,
  ...adminRouteRoleCategory,
  ...adminRouteRoleChecklist,
  ...adminRouteJob,
  ...adminRouteQuarantine,
  ...adminRouteInvoice,
  ...adminRouteReport,
  ...adminRouteTask,
  ...adminRouteGlobal,
};
